import api from '@utils/api'
import { getValueLanguageObj } from '@utils/general'

export const getListRoles = (group) => async (dispatch, getState) => {
  const querys = {
    group: group
  }
  const response = await api.getListRoles(querys)
  return response
}

export const getListUsersByRole = (roleId, status = 'all') => async (dispatch, getState) => {
  const response = await api.getListUsersByRole(roleId, {status})
  return response
}

export const getListRegionTree = () => async (dispatch, getState) => {
  const response = await api.getListRegionTree()
  return response
}

export const addUserIntoRole = ({ id_rol, correo, admin_paises, paises, admin_empresas }) => async (dispatch, getState) => {
  const data = {
    id_rol,
    correo,
    admin_paises,
    admin_empresas,
    paises,
  };
  const response = await api.addUserIntoRole(data)
  return response
}

export const addCocUserIntoRole = ({ id_rol, correo, admin_paises, paises, admin_empresas, id_coordinador }) => async (dispatch, getState) => {
  const data = {
    id_rol,
    correo,
    admin_paises,
    admin_empresas,
    paises,
    id_coordinador,
  };
  const response = await api.addCocUserIntoRole(data)
  return response
}

export const updateUserIntoRole = ({ id_rol, correo, admin_paises, paises, admin_empresas }) => async (dispatch, getState) => {
  const data = {
    id_rol,
    correo,
    admin_paises,
    admin_empresas,
    paises,
  };
  const response = await api.updateUserIntoRole(data)
  return response
}

export const deleteRoleUser = ({ id_rol, correo}) => async (dispatch, getState) => {
  const data = {
    id_rol,
    correo,
  };
  const response = await api.deleteRoleUser(data)
  return response
}

export const assignPrincipalUser = ({ id_rol, correo}) => async (dispatch, getState) => {
  const data = {
    id_rol,
    correo,
  };
  const response = await api.assignPrincipalUser(data)
  return response
}

export const getRegion = () => async (dispatch, _getState) => {
  const response = await api.getListRegionTree()
  let lstPaises = []
  if(response.data){
    response.data.map(p => {
      const valuePais = getValueLanguageObj(JSON.parse(p.nombre))
      let lstEmpresas = []
      
      p?.empresas.map(e => {
        let lstRegiones = []
        e?.regiones?.map(r => {
          const region = {
            key: `P${p.id}-E${e.id}-R${r.id}`,
            label: r.nombre,
            data: `${r.nombre} Region`,
            id: r.id,
            tipo: 'r',
            empresa: {
              id: e.id,
              label: e.nombre,
            },
            pais: {
              id: p.id,
              label: valuePais,
            }
          }
          lstRegiones.push(region)
        })
        const empresa = {
          key: `P${p.id}-E${e.id}`,
          label: e.nombre,
          data: `${e.nombre} Empresa`,
          children: lstRegiones,
          id: e.id,
          tipo: 'e',
          pais: {
            id: p.id,
            label: valuePais,
          }
        }
        lstEmpresas.push(empresa)
      })
      
      const pais = {
        key: `P${p.id}`,
        label: valuePais,
        data: `${valuePais} País`,
        children: lstEmpresas,
        tipo: 'p',
        id: p.id
      }
      lstPaises.push(pais)
    })

   return lstPaises
  } else {
    return lstPaises
  }

  /*return [
    {
      key: "P10",
      label: "México",
      data: "México País",
      children: [
        {
          key: "P10-E28",
          label: "Telcel",
          data: "Telcel Empresa",
          children: [
            {
              key: "P10-E28-R3",
              label: "Chihuahua",
              data: "Chihuahua Región"
            },
            {
              key: "P10-E28-R10",
              label: "Corporativo",
              data: "Corporativo Región"
            },
            {
              key: "P10-E28-R5",
              label: "Guadalajara",
              data: "Guadalajara Región"
            }
          ]
        },
        {
          key: "P10-E15",
          label: "HITSS",
          data: "HITSS Empresa",
          children: [
            {
              key: "P10-E15-R1",
              label: "Región 1",
              data: "Región 1 Región"
            },
            {
              key: "P10-E15-R2",
              label: "Región 2",
              data: "Región 2 Región"
            }
          ]
        }
      ]
    },
    {
      key: "P13",
      label: "Paraguay",
      data: "Paraguay País",
      children: [
        {
          key: "P13-E20",
          label: "Claro",
          data: "Claro Empresa",
          children: [
            {
              key: "P13-E20-R11",
              label: "Región 1",
              data: "Región 1 Región"
            },
            {
              key: "P13-E20-R22",
              label: "Región 2",
              data: "Región 2 Región"
            }
          ]
        }
      ]
    }
  ]*/
};

export const updateEvaluator = (newData) => async (dispatch, getState) => {
  const { id, nombre, url, estatus, contacto } = getState().evaluator
  const data = {
    id,
    nombre,
    url,
    estatus,
    contacto,
    ...newData
  }
  data.contacto = JSON.stringify(data.contacto)
  const response = await api.updateEvaluator(data)
  return response
}
